import { useState } from "react"
import { Checkbox, Flex, Form } from "antd"
import { useTranslation } from "react-i18next"
import { Button } from "../../components/Button"
import { ContentWrapper } from "../../components/Wrappers"
import {
  WEB_PORTALS,
  STORAGE_ENCRYPTED_DATA,
  STORAGE_IV,
} from "../../constants"
import { getStorageVariable } from "../../utils/storage"
import { ProgressBar } from "../../components/ProgressBar"
import { clearCache } from "../../services/clear-cache"
import { useNotification } from "../../context/Notification"

const { slovakCryptoNews, slovakFtNews, czechCryptoNews, czechFtNews } =
  WEB_PORTALS

export const ClearCache: React.FC = () => {
  const { t } = useTranslation()
  const notification = useNotification()
  const [message, setMessage] = useState<{
    data: { portalName: string; progress: number }
    message: string
  }>({
    data: { portalName: "", progress: 0 },
    message: "",
  })
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()

  const knSkData = getStorageVariable(
    `${slovakCryptoNews}${STORAGE_ENCRYPTED_DATA}`,
  )
  const knSkIv = getStorageVariable(`${slovakCryptoNews}${STORAGE_IV}`)
  const ftnSkData = getStorageVariable(
    `${slovakFtNews}${STORAGE_ENCRYPTED_DATA}`,
  )
  const ftnSkIv = getStorageVariable(`${slovakFtNews}${STORAGE_IV}`)
  const knCzData = getStorageVariable(
    `${czechCryptoNews}${STORAGE_ENCRYPTED_DATA}`,
  )
  const knCzIv = getStorageVariable(`${czechCryptoNews}${STORAGE_IV}`)
  const ftnCzData = getStorageVariable(
    `${czechFtNews}${STORAGE_ENCRYPTED_DATA}`,
  )
  const ftnCzIv = getStorageVariable(`${czechFtNews}${STORAGE_IV}`)

  const onFinish = async (values: any) => {
    setIsLoading(true)
    if (!values.knSk && !values.ftnSk && !values.knCz && !values.ftnCz) {
      notification.error(
        t("cacheClearing.noPortalSelected"),
        t("cacheClearing.noPortalSelectedDesc"),
      )
      setIsLoading(false)
      return
    }
    await clearCache(
      {
        knSkData,
        knSkIv,
        ftnSkData,
        ftnSkIv,
        knCzData,
        knCzIv,
        ftnCzData,
        ftnCzIv,
      },
      values,
      (partialMessage) => {
        setMessage(JSON.parse(partialMessage))
      },
    )
    setIsLoading(false)
    form.resetFields()
  }

  return (
    <ContentWrapper>
      <Flex vertical gap="large">
        <Flex justify="center" vertical gap="large">
          <Form
            form={form}
            name="dynamic_form_item"
            onFinish={onFinish}
            layout="vertical"
            disabled={isLoading}
            initialValues={{
              knSk: false,
              ftnSk: false,
              knCz: false,
              ftnCz: false,
            }}
          >
            <Flex vertical justify="center" align="center">
              <Form.Item name="knSk" valuePropName="checked">
                <Checkbox>Kryptonovinky SK</Checkbox>
              </Form.Item>
              <Form.Item name="ftnSk" valuePropName="checked">
                <Checkbox>FT News SK</Checkbox>
              </Form.Item>
              <Form.Item name="knCz" valuePropName="checked">
                <Checkbox>Kryptonovinky CZ</Checkbox>
              </Form.Item>
              <Form.Item name="ftnCz" valuePropName="checked">
                <Checkbox>FT News CZ</Checkbox>
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "300px" }}
                  loading={isLoading}
                  label={
                    isLoading
                      ? t("cacheClearing.clearing")
                      : t("cacheClearing.clear")
                  }
                />
              </Form.Item>
            </Flex>
          </Form>
          {message.data.progress > 0 && (
            <ProgressBar
              progress={message.data.progress}
              message={message.message}
              process="cacheClearing"
              articleName={message.data.portalName}
            />
          )}
        </Flex>
      </Flex>
    </ContentWrapper>
  )
}
